module.exports = __webpack_public_path__ + "img/message-success.7d962fc2.png";